import { Component, Input, OnInit} from '@angular/core';
import { ContextFactory } from '@shared/factories/context/context.factory';
import { ApiPropertiesFactory } from '@shared/factories/api-properties/api-properties.factory';
import { GlobalCfgFactory } from '@shared/factories/global-cfg/global-cfg.factory';
import { CommonUtilsService } from '@shared/services/common-utils/common-utils.service';
import { PopoverModule } from 'primeng/popover';
import { TooltipModule } from 'primeng/tooltip';
import { SharedModule } from 'primeng/api';
import { MenuModule } from 'primeng/menu';
import { SpanTooltipComponent } from '../span-tooltip/span-tooltip.component';
import { NgClass } from '@angular/common';
import { AfTranslatePipe } from '@shared/modules/translate/pipe/af-translate.pipe';

@Component({
    selector: 'header-landing',
    templateUrl: './header-landing.component.html',
    styleUrl: './header-landing.component.scss',
    imports: [
        NgClass,
        SpanTooltipComponent,
        MenuModule,
        SharedModule,
        TooltipModule,
        PopoverModule,
        AfTranslatePipe
    ]
})
export class HeaderLandingComponent implements OnInit {
  skin: string =  this.globalCfg.skin;
  headerLanding:any ={
    selectedLanguage: {},
    languages: this.commonUtilsService.configureAvailableLanguages(this.apiProperties.availableLanguages),
  }
  constructor(private context: ContextFactory,
    private globalCfg: GlobalCfgFactory,
    private apiProperties: ApiPropertiesFactory,
    private commonUtilsService: CommonUtilsService) { }
  @Input() configuration:any;

  ngOnInit(): void {
    this.getTranslate();
  }

  configInit(){
    this.getTranslate();
  }

  getTranslate(){
    let language:any = sessionStorage.getItem('selectLanguage');
    if(language){
      this.headerLanding.selectedLanguage = this.catchDefaultLanguage(language);
    }else if(this.context.user.culture){
      this.headerLanding.selectedLanguage = this.catchDefaultLanguage(this.context.user.culture);
    }else{
      this.headerLanding.selectedLanguage = this.catchDefaultLanguage();
    }
  }

  catchDefaultLanguage(culture:any = false){
    let language = culture? culture : this.apiProperties.defaultLanguage;
    for(let i = 0; i < this.headerLanding.languages.length; i++){
      if(language === this.headerLanding.languages[i].listValueId){
        return this.headerLanding.languages[i];
      }
    }
  }

  changeAppLanguage(language:any){
    sessionStorage.setItem('selectLanguage', language.appLanguage);
    window.location.reload();
  }

  logOut() {
    window.location.href = this.globalCfg.externalPublicLogoutUrl == null
        ? window.location.origin + '/gestionUsuarios/Desconexion.jsp'
        : this.globalCfg.externalPublicLogoutUrl;
  }
}
